import { useMemo } from 'react';
import { getPhaseProgress } from './useLtcFinancialPlanningNavigation';

interface UseProgressBarStepStateOptions {
  stepId: number;
  currentProgressStep: number;
  currentStep: LtcFinancialPlanningStep;
}

interface ProgressBarStepState {
  isCompleted: boolean;
  isCurrent: boolean;
  progressPercent: number;
  textColorClass: string;
}

/**
 * Custom hook to calculate the state and styling for a progress bar step
 */
export function useProgressBarStepState({
  stepId,
  currentProgressStep,
  currentStep,
}: UseProgressBarStepStateOptions): ProgressBarStepState {
  return useMemo(() => {
    const isCompleted = currentProgressStep > stepId;
    const isCurrent = currentProgressStep === stepId;

    // Calculate progress percentage for the bar
    let progressPercent = 0;
    if (isCompleted) {
      progressPercent = 100;
    } else if (isCurrent) {
      progressPercent = getPhaseProgress(stepId, currentStep);
    }

    // Determine text color class
    let textColorClass = 'text-gray-400'; // Future steps
    if (isCompleted) {
      textColorClass = 'text-primary'; // Completed steps
    } else if (isCurrent) {
      textColorClass = 'text-gray-900'; // Current step
    }

    return {
      isCompleted,
      isCurrent,
      progressPercent,
      textColorClass,
    };
  }, [stepId, currentProgressStep, currentStep]);
}
